module.exports = __webpack_public_path__ + "static/media/Canada.6ccb6b84.png";